/* istanbul ignore file */

/**
 * Manually added this enum to match FilterTypeDTO
 */
export enum FilterType {
  Bool,
  Input,
  AutoComplete,
}
